import React from "react";
import sampleImage from "../assets/SiteImages/ATXPlantRescueImage19.jpg";
import Award from "../assets/newimage/first33.png";

function Hero() {
  return (
    <header
      className="relative bg-cover bg-center bg-no-repeat text-[#1A3C34] min-h-[90vh] flex items-center py-20 sm:py-24"
      style={{ backgroundImage: `url(${sampleImage})` }}
    >
      {/* Overlay for better text visibility */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Main Content */}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 sm:px-10 text-center lg:text-left">
        <div className="max-w-2xl">
          <h1 className="text-5xl sm:text-6xl md:text-6xl font-semibold leading-tight text-white">
            Keeping Austin {' '} <br/> <span className="text-[#C17C45] italic font-bold">Plants Thriving</span>
          </h1>

          <p className="mt-4 sm:mt-6 text-[20px] text-white max-w-[600px] mx-auto lg:mx-0">
            Your plants deserve expert care, whether they’re drooping, yellowing,
            or just in need of a fresh start. At ATX Plant Rescue, we specialize
            in plant health checks, new plant setups, and rescue services for
            homes, offices, and businesses across Austin.
          </p>

          <p className="mt-4 md:text-[20px] max-w-[450px] mx-auto lg:mx-0 text-white ">
            Let us help your plants look their best — and keep them that way.
          </p>

          <div className="mt-6">
            <a href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services"> 
            <button className="bg-[#1A3C34] w-full sm:w-auto px-6 py-2 sm:py-3 text-white text-[18px] font-semibold rounded-full hover:bg-[#2e5d50] transition-colors duration-300">
              View Our Services
            </button>
            </a>
          </div>
        </div>
      </div>

      {/* Optional Award Element */}
      {/* <img
        src={Award}
        alt="decorative element"
        className="absolute top-8 right-8 hidden sm:block lg:top-16 lg:right-20 w-32 h-32 object-cover rounded-md transform rotate-12 z-20"
      /> */}
    </header>
  );
}

export default Hero;
